module.exports = __webpack_public_path__ + "media/images/photo04-2897a57a1584bd9d03ce8eae88b372f7.png";